function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 52,
  height: 52,
  rx: 26,
  fill: "#F5F5F5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.705 30.0721C29.689 29.4921 29.065 28.9381 28.911 27.9151C28.895 27.8295 28.899 27.7415 28.9226 27.6577C28.9461 27.5739 28.9887 27.4967 29.047 27.4321C29.757 26.6981 30.116 24.6771 30.116 24.0551C30.611 23.3591 30.691 22.9311 30.952 21.8061C31.149 20.9541 30.722 20.6261 30.502 20.5161C30.438 20.4861 30.401 20.4011 30.415 20.3311C31.362 15.8431 28.698 14.4731 27.85 14.6321C24.854 13.3201 23.37 14.2841 22.51 15.4091C21.098 15.9531 21.101 18.7251 21.576 20.3121C21.5883 20.3524 21.5861 20.3957 21.5696 20.4345C21.5532 20.4733 21.5236 20.505 21.486 20.5241C21.261 20.6421 20.857 20.9761 21.049 21.8061C21.309 22.9311 21.39 23.3591 21.885 24.0561C21.885 24.6771 22.244 26.6981 22.954 27.4321C23.076 27.5571 23.117 27.7421 23.09 27.9151C22.935 28.9381 22.311 29.4921 20.296 30.0721C16.57 31.1451 16 33.0071 16 37.0021C16 37.1331 16.0258 37.2629 16.076 37.384C16.1261 37.5051 16.1996 37.6151 16.2923 37.7078C16.385 37.8005 16.495 37.874 16.6161 37.9241C16.7372 37.9743 16.8669 38.0001 16.998 38.0001H35.003C35.1339 38.0002 35.2635 37.9746 35.3845 37.9246C35.5054 37.8746 35.6153 37.8012 35.7079 37.7087C35.8005 37.6162 35.874 37.5064 35.9241 37.3855C35.9742 37.2646 36 37.135 36 37.0041V37.0011C36 33.0071 35.431 31.1451 31.705 30.0721",
  fill: "#7B7C7C"
});

function SvgDefaultAvatar2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar2);
export default ForwardRef;